export default __webpack_public_path__ + "static/media/company_logo.986b59a6.png";